<div class="pages-parent">
  <rotec-shell-v2 (sideBarCollapse)="sideBarCollapse($event)"></rotec-shell-v2>
</div>
